<script>
import baseMixin from '@/mixins/baseMixin'
import DateComponent from '@components/general/date-component.vue'
import ClientDetailsListItem from '@components/general/client-details-list-item.vue'

export default {
  name: 'SubBubbleAgreementsList',
  components: {
    DateComponent,
    ClientDetailsListItem,
  },
  mixins: [baseMixin],
  props: {
    agreements: {
      type: Array,
      required: true,
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
    isClientGroup: {
      type: Boolean,
      required: true,
    },
  },
  data: (vm) => {
    return {
      headers: [
        {
          text: 'Client',
          value: 'client',
        },
        {
          text: vm.$t('subBubbleAgreements.columnHeadings.startDate'),
          value: 'startDateLocal',
        },
        {
          text: vm.$t('subBubbleAgreements.columnHeadings.endDate'),
          value: 'endDateLocal',
        },
        {
          text: vm.$t(
            'subBubbleAgreements.columnHeadings.classificationDiscounts'
          ),
          value: 'discounts',
          cellClass: 'classification-discounts-column',
          sortable: false,
        },
        {
          text: vm.$t('subBubbleAgreements.columnHeadings.actions'),
          value: 'actions',
          sortable: false,
          align: 'end',
        },
      ],
    }
  },
  methods: {
    getClassificationDiscountChipText(discount) {
      const classificationName =
        discount.classificationName ??
        this.$t('subBubbleAgreements.allClassificationsText')
      return `${classificationName} (${this.$n(discount.value)}%)`
    },
    getClassificationDiscountChipTooltip(discount) {
      return this.$t('subBubbleAgreements.classificationDiscountChipTooltip', {
        candidateCount: this.$n(discount.candidateCount),
        discount: this.$n(discount.value),
      })
    },
    getDiscountText(agreement) {
      return `${this.$n(agreement.defaultDiscountValue)}%`
    },
    cleanseIdForClientDetailsListItem(id) {
      return Number.isInteger(id) ? id : -1
    },
    displayActions(discount) {
      return this.isClientGroup || discount.isClientGroup === this.isClientGroup
    },
  },
}
</script>

<template>
  <v-data-table
    class="sub-bubble-agreements-table elevation-1"
    :headers="headers"
    :sort-by="['startDateLocal']"
    :items="agreements"
    :loading="isLoading"
    :loading-text="$t('subBubbleAgreements.loadingListMessage')"
  >
    <template v-slot:item.actions="{ item }">
      <v-icon
        v-if="displayActions(item)"
        small
        class="mr-2"
        @click="$emit('on-edit', item)"
      >
        mdi-pencil
      </v-icon>
      <v-icon
        v-if="displayActions(item)"
        small
        @click="$emit('on-delete', item)"
      >
        mdi-delete
      </v-icon>
    </template>
    <template v-slot:item.client="{ item }">
      <ClientDetailsListItem
        :group-id="cleanseIdForClientDetailsListItem(item.clientGroupId)"
        :client-id="cleanseIdForClientDetailsListItem(item.clientId)"
      />
    </template>
    <template v-slot:item.startDateLocal="{ item }">
      <DateComponent :date="item.startDateLocal"></DateComponent>
    </template>
    <template v-slot:item.endDateLocal="{ item }">
      <DateComponent :date="item.endDateLocal"></DateComponent>
    </template>
    <template v-slot:item.candidateCount="{ item }">
      {{ $n(item.candidateCount) }}
    </template>
    <template v-slot:item.defaultDiscountValue="{ item }">
      {{ getDiscountText(item) }}
    </template>
    <template v-slot:item.discounts="{ item }">
      <span
        v-for="(discount, index) in item.discounts"
        :key="index"
        class="my-1 ml-1"
      >
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-chip small v-on="on">
              {{ getClassificationDiscountChipText(discount) }}
            </v-chip>
          </template>
          <span>{{ getClassificationDiscountChipTooltip(discount) }}</span>
        </v-tooltip>
      </span>
    </template>
  </v-data-table>
</template>
